/* eslint-disable prettier/prettier */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable no-promise-executor-return */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Box, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import PageSyncCal from "../../../../components/Layout/PageSyncCal";
import Heading from "../../../../components/Layout/Heading/NewHeading";
import { OuterContainerStyles } from "../../../../components/Layout/Typography";
import { SERVICES } from "../../../../components/Layout/Services";
import { get } from "../../../../components/Layout/ApiHandler/apihandler";
import Loader from "../../../../components/Loader/Loader";
import CurrentAppointment from "./CurrentAppointment";
import PreviousAppointment from "./PreviousAppointment";
import UinUpdateModal from "../../Components/Alert/UinUpdateModal";

function MemberDetails() {
  const { memberId } = useParams();
  const [memberData, setMemberData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [memberUin, setMemberUin] = useState({});
  const [uinValue, setUinValue] = useState("");
  const [selectedUinType, setSelectedUinType] = useState("");
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [profileData, setProfileData] = useState({});
  const today = new Date();
  const threeDaysLater = new Date();
  threeDaysLater.setDate(today.getDate() + 2);
  const getUserProfile = async () => {
    try {
      setIsLoading(true);
      const url = `${SERVICES.GET_MEMBER}/${memberId}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberData(data.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      } else {
        console.error("Failed to fetch Division Type data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  const getMemberUin = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/uin`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberUin(data.data);
        setUinValue(data?.data[0]?.uin);
        setSelectedUinType(data?.data[0]?.uinType);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleUpdateModal = () => {
    setUpdateModalOpen(false);
  };
  useEffect(() => {
    getUserProfile();
    getMemberUin();
  }, [memberId]);
  useEffect(() => {
    getUserRole();
  }, []);
  const getConcatenatedUinTypes = () => {
    return memberUin?.map((uin) => uin?.uinType.replace(/_/g, " "))?.join(", ");
  };
  const getConcatenatedUinValues = () => {
    return memberUin?.map((uin) => uin?.uin)?.join(", ");
  };
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <PageSyncCal />
      <Heading title="Member Details" />
      <OuterContainerStyles
        marginTop="24px"
        marginBottom="24px"
        style={{ padding: "24px" }}
      >
        <OuterCard>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Organization Structure
          </OuterCardHeading>
          <OuterCardText>
            {`${memberData.areaName || "NA"} /
             ${memberData.clusterName || "NA"} / 
             ${memberData.zoneName || "NA"} /
              ${memberData.regionName || "NA"} / 
              ${memberData.chapterName || "NA"} /
              ${memberData.districtName || "NA"} / 
              ${memberData.blockName || "NA"}`}
          </OuterCardText>
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Member Details
          </OuterCardHeading>
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>Member Name</MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData?.fullName || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv>
          <MemberDetailsDiv2>
            <MemberDetailsTextHeading>Address</MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData?.addressLine1 || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv2>
          <MemberDetailsDiv>
            <MemberDetailsTextHeading>State</MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData?.stateName || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv>
          <MemberDetailsDiv2>
            <MemberDetailsTextHeading>City</MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData?.cityName || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv2>
          <MemberDetailsDiv>
            <MemberDetailsTextHeading>Pin Code</MemberDetailsTextHeading>
            <MemberDetailsText>{memberData?.pincode || "NA"}</MemberDetailsText>
          </MemberDetailsDiv>
          <MemberDetailsDiv2>
            <MemberDetailsTextHeading>Contact Info</MemberDetailsTextHeading>
            <MemberDetailsText>
              {`${memberData.emailId}  /  ${memberData.mobileNumber}`}
            </MemberDetailsText>
          </MemberDetailsDiv2>
          {/* <MemberDetailsDiv2 largePadding>
            <MemberDetailsTextHeading>Gohonzon Member</MemberDetailsTextHeading>
            <MemberDetailsText>
              {" "}
              {memberData.gohonzonMemberships &&
              memberData.gohonzonMemberships.length > 0
                ? memberData.gohonzonMemberships[0].type
                : "No"}
            </MemberDetailsText>
          </MemberDetailsDiv2> */}
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>
              Division/Sub Division
            </MemberDetailsTextHeading>
            <MemberDetailsText> {memberData?.divisionName}</MemberDetailsText>
          </MemberDetailsDiv>
        </OuterCard>
        {memberUin.length > 0 && (
          <OuterCard style={{ marginTop: "24px" }}>
            <OuterCardHeading fontSize="18px" fontWeight="500">
              Member Uin Details
            </OuterCardHeading>
            <MemberDetailsDiv largePadding>
              {memberUin.length > 0 && (
                <>
                  <MemberDetailsTextHeading>UIN type</MemberDetailsTextHeading>
                  <MemberDetailsText>
                    {getConcatenatedUinTypes() || "NA"}
                  </MemberDetailsText>
                  {profileData?.assignedRoles?.includes(
                    "contributionAdmin",
                  ) && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        marginLeft: "auto",
                      }}
                    >
                      <Tooltip title="Update Member Uin" placement="top">
                        <EditIcon
                          sx={{ fontSize: "medium", cursor: "pointer" }}
                          onClick={() => setUpdateModalOpen(true)}
                        />
                      </Tooltip>
                    </Box>
                  )}
                </>
              )}
            </MemberDetailsDiv>
            <MemberDetailsDiv2 largePadding>
              {memberUin.length > 0 && (
                <>
                  <MemberDetailsTextHeading>UIN value</MemberDetailsTextHeading>
                  <MemberDetailsText>
                    {getConcatenatedUinValues() || "NA"}
                  </MemberDetailsText>
                </>
              )}
            </MemberDetailsDiv2>
          </OuterCard>
        )}
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Professional Details
          </OuterCardHeading>
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>University</MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData?.universityName || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv>
          <MemberDetailsDiv2 largePadding>
            <MemberDetailsTextHeading>College</MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData?.collegeName || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv2>
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>Profession</MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData.professionName || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv>
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Additional Info
          </OuterCardHeading>
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>
              Introducer's Name
            </MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData?.introducerName || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv>
          <MemberDetailsDiv2 largePadding>
            <MemberDetailsTextHeading>
              Introducer's Number
            </MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData?.introducerMobileNumber || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv2>
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>
              {" "}
              Introducer's Email
            </MemberDetailsTextHeading>
            <MemberDetailsText>
              {memberData?.introducerEmail || "NA"}
            </MemberDetailsText>
          </MemberDetailsDiv>
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Current Appointment
          </OuterCardHeading>
          <CurrentAppointment />
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Previous Appointment
          </OuterCardHeading>
          <PreviousAppointment />
        </OuterCard>
        <Footer>
          <FooterText>
            Please verify the contributor’s name. If you find any error, do not
            proceed. Contact your Region Stats In-charge for correction. Once
            you proceed, the name cannot be corrected in this financial year.
          </FooterText>
        </Footer>
      </OuterContainerStyles>
      <UinUpdateModal
        open={updateModalOpen}
        onClose={handleUpdateModal}
        getUinDetails={getMemberUin}
      />
      {isLoading && <Loader />}
    </div>
  );
}

export default MemberDetails;

const OuterCard = styled.div`
  display: flex;
  padding: 12px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c5c5d1;
  background: #f5f5f5;
`;

const OuterCardHeading = styled.p`
  margin: 0;
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
const OuterCardText = styled.p`
  margin: 0;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
const MemberDetailsDiv = styled.div`
  display: flex;
  padding: ${(props) => (props.largePadding ? "16px" : "7px")} 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 1px solid #62b6da;
  background: #fff;
`;
const MemberDetailsDiv2 = styled.div`
  display: flex;
  padding: 7px 24px;
  padding: ${(props) => (props.largePadding ? "16px" : "7px")} 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 1px solid #62b6da;
  background: #e8f6fc;
`;
const MemberDetailsTextHeading = styled.p`
  margin: 0;
  width: 250px;
  color: #484848;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;
const MemberDetailsText = styled.p`
  margin: 0;
  width: 270px;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
`;
const FieldsDiv = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: 146px;
  align-self: stretch;
`;

const Footer = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

const FooterText = styled.p`
  color: #e41717;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
`;

const ButtonContainer = styled.div`
  display: flex;
  padding: 24px 30px;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;
const NodataText = styled.p`
  color: #e41717;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;
